export const vi = {
  errors: {
    'core-files': {
      too_large: 'File quá lớn.',
      unsupported_type: 'Loại file không được hỗ trợ.',
      missing_file: 'Chưa chọn file.',
    },
  },
};

export const en: typeof vi = {
  errors: {
    'core-files': {
      too_large: 'The file is too large.',
      unsupported_type: 'This file type is not supported.',
      missing_file: 'No file was sent.',
    },
  },
};
